import { dialogsEventBus } from '@/features/globalDialogs';
import type { App } from 'vue';

export const globalDialogsPlugin = {
    install(app: App) {
        app.config.globalProperties.$triggerDialog = dialogsEventBus.emit.bind(dialogsEventBus);
    },
};
